if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        if (this.form.querySelector('[name=id]')) this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        if (this.querySelector('[name=id]')) this.querySelector('[name=id]').disabled = false;
        if (this.querySelector('button[type=submit]')) this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = this.form ? new FormData(this.form) : new FormData();
      if (!formData.get('id') && this.querySelector('[name=id]')) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // dispatch cart:error
            document.dispatchEvent(
              new CustomEvent('cart:error', {
                detail: {
                  source: this.dataset.source,
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            // dispatch cart:error
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart || typeof this.cart.renderContents !== 'function') {
            window.location = window.routes.cart_url;
            return;
          }

          // dispatch variant:add
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get('id')
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source
              }
            })
          );
          // dispatch variant:add

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state)

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source
                  }
                })
              );
              // dispatch cart:change for the entire basket

            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            });

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                try {
                  this.cart.renderContents(response);
                } catch (error) {
                  console.error('Cart drawer render failed:', error);
                  window.location = window.routes.cart_url;
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            try {
              this.cart.renderContents(response);
            } catch (error) {
              console.error('Cart drawer render failed:', error);
              window.location = window.routes.cart_url;
            }
          }
        })
        .catch((e) => {
          console.error(e);
          if (this.form && !this.dataset.fallbackSubmitted) {
            this.dataset.fallbackSubmitted = 'true';
            this.form.submit();
            return;
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

(function () {
  function enableAvailableProductForms() {
    document.querySelectorAll('product-form').forEach((productForm) => {
      const form = productForm.querySelector('form');
      const idInput = productForm.querySelector('[name="id"]');
      const submitButton = productForm.querySelector('[name="add"]');

      if (!form || !idInput || !submitButton || !idInput.value) return;
      if (submitButton.querySelector('.sold-out-message:not(.hidden)')) return;

      idInput.disabled = false;
      submitButton.disabled = false;
      submitButton.removeAttribute('disabled');
      submitButton.removeAttribute('aria-disabled');
      submitButton.classList.remove('disabled');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableAvailableProductForms);
  } else {
    enableAvailableProductForms();
  }

  document.addEventListener('variant:change', enableAvailableProductForms);
  document.addEventListener('shopify:section:load', enableAvailableProductForms);
  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-radios, variant-selects, product-form')) {
      window.setTimeout(enableAvailableProductForms, 0);
      window.setTimeout(enableAvailableProductForms, 250);
    }
  });
})();
